var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.875 4.5C19.2202 4.5 19.5 4.77982 19.5 5.125V18.875C19.5 19.2202 19.2202 19.5 18.875 19.5C18.5298 19.5 18.25 19.2202 18.25 18.875V5.125C18.25 4.77982 18.5298 4.5 18.875 4.5Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10.125C17 10.8154 16.4404 11.375 15.75 11.375L8.25 11.375C7.55964 11.375 7 10.8154 7 10.125V7C7 6.30964 7.55964 5.75 8.25 5.75L15.75 5.75C16.4404 5.75 17 6.30964 17 7V10.125ZM8.25 10.125L15.75 10.125V7L8.25 7V10.125Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.875 13.875C3.875 13.1846 4.43464 12.625 5.125 12.625H15.75C16.4404 12.625 17 13.1846 17 13.875V17C17 17.6904 16.4404 18.25 15.75 18.25H5.125C4.43464 18.25 3.875 17.6904 3.875 17V13.875ZM15.75 13.875H5.125V17H15.75V13.875Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/align-right.df26b2d4b381416a32ef4039e30e1e62.svg";
export { ForwardRef as ReactComponent };